'use strict';

var Utils = require('../../utils/utils');

var NavVisibility = function(config) {

  var self = this;

  self.findElements = function() {
    $(config.nav).each(function() {

      var $this = $(this);
      var $navToggle = $this.find(config.navToggle);
      var $navList = $this.find(config.navList);
      // var $panelButton = $this.find(config.panelButton);

      self.clickHandler($this, $navToggle, $navList);
      // self.panelButtonClickHandler($panelButton, $this, $navToggle, $navList);
    });
  }

  self.clickHandler = function($nav, $navToggle, $navList) {
    $navToggle.on('click.chronologyNavVisibility', new Utils().throttle(function() {
      self.visibility($nav, $navToggle, $navList);
    }, 300));
  }

  self.visibility = function($nav, $navToggle, $navList) {
    if ($navList.hasClass('is-visible') && !$navList.hasClass('velocity-animating')) {
      self.hideNav($nav, $navToggle, $navList);
    } else if (!$navList.hasClass('velocity-animating')) {
      self.showNav($nav, $navToggle, $navList);
    }
  }

  self.showNav = function($nav, $navToggle, $navList) {
    $navList
      .addClass('is-visible')
      .velocity('slideDown',{
        easing: 'easeOutQuart',
        duration: 300,
        complete: function() {
          $navToggle
            .addClass('is-active')
            .attr('aria-expanded', 'true');
        }
      })
      .velocity({
        opacity: 1
      });
    $nav.addClass('is-open');
  }

  self.hideNav = function($nav, $navToggle, $navList, delay) {
    var delay = delay || 0;
    $navList
      .removeClass('is-visible')
      .velocity({
        opacity: 0
      })
      .velocity('slideUp',{
        easing: 'easeOutQuart',
        duration: 200,
        delay: delay,
        complete: function() {
          $navToggle
            .removeClass('is-active')
            .attr('aria-expanded', 'false');
        }
      });
    $nav.removeClass('is-open');
  }

  // self.panelButtonClickHandler = function($panelButton, $nav, $navToggle, $navList) {
  //   $panelButton.on('click.chronologyNavVisibility', function() {
  //     self.hideNav($nav, $navToggle, $navList, 300);
  //   })
  // }


  self.destroy = function() {
    $(config.nav).removeClass('is-open');
    $(config.navToggle)
      .off('click.chronologyNavVisibility')
      .removeClass('is-active');
    $(config.panelButton)
      .off('click.chronologyNavVisibility');
    $(config.navList)
      .removeClass('is-visible')
      .removeAttr('style');
  }

  self.init = function() {

    var largeViewports = function() {
      self.destroy();
    };

    var smallViewports = function() {
      self.findElements();
    };

    new Utils().matchmediaHandler('MEDIUM', largeViewports, smallViewports);
  }
};

module.exports = NavVisibility;
